import React, { useState } from 'react'
import './GameSummary.css'
import HomeHeader from './HomeHeader'
import HomeNavLinks from './HomeNavLinks'
import SideDrawer from '../../../admin/components/SideDrawer'
import Backdrop from '../UIElements/Backdrop'
import gameSummaryLogo from '../../../images/gameSummary_transparent.png'
import k_logo from '../../../images/K_logo_transparent.png'

const GameSummaryNavigation = (props) => {
	const [drawerIsOpen, setDrawerIsOpen] = useState(false)

	/* console.log(
		'GameSummary props: ' + JSON.stringify(props.leagueId)    < - - gameId??
	) */

	const openDrawerHandler = () => {
		setDrawerIsOpen(true)
	}

	const closeDrawerHandler = () => {
		setDrawerIsOpen(false)
	}

	return (
		<React.Fragment>
			{drawerIsOpen && <Backdrop onClick={closeDrawerHandler} />}
			<SideDrawer show={drawerIsOpen} onClick={closeDrawerHandler}>
				<nav className='gameSummary-navigation__drawer-nav'>
					{/* <HomeNavLinks leagueId={props.leagueId} /> */}
					<HomeNavLinks />
				</nav>
			</SideDrawer>
			<HomeHeader>
				<button
					className='gameSummary-navigation__menu-btn'
					onClick={openDrawerHandler}
				>
					<span />
					<span />
					<span />
				</button>
				{/* <h1 className='gameSummary-navigation__title'>Game Summary</h1> */}
				<div className='headerWidth'>
					<img src={gameSummaryLogo} className='scoringLeadersLogo' />
					<a
						href='https://knapperusa.com/'
						target='_blank'
						rel='noopener noreferrer'
					>
						<img
							src={k_logo}
							className='k_gamesummary_Logo'
							alt='Knapper USA'
						/>
					</a>
				</div>
				<nav className='gameSummary-navigation__header-nav'>
					{/* <HomeNavLinks leagueId={props.leagueId} /> */}
					<HomeNavLinks />
				</nav>
			</HomeHeader>
		</React.Fragment>
	)
}

export default GameSummaryNavigation
